module.exports = __webpack_public_path__ + "media/images/property_photo3-282a5e38.jpg";